import { Injectable } from '@angular/core';

@Injectable()
export class TrebekQueryMappingService {
    private trebekQueryIdWidgetMappings: QueryIdToWidgetId[] = [];

    updateTrebekQueryIdWidgetMappings(widgetIds: number[], queryId: string): void {
        // Remove each widgetId from any other mappings
        widgetIds.forEach((widgetId) => {
            this.trebekQueryIdWidgetMappings.forEach((mapping) => {
                if (mapping.queryId !== queryId && mapping.widgetIds.includes(widgetId)) {
                    mapping.widgetIds = mapping.widgetIds.filter((id) => id !== widgetId);
                }
            });
        });

        // Remove mappings with empty widgetIds
        this.trebekQueryIdWidgetMappings = this.trebekQueryIdWidgetMappings.filter((m) => m.widgetIds.length > 0);

        // Check if a mapping for this queryId already exists
        const existingMapping = this.trebekQueryIdWidgetMappings.find((mapping) => mapping.queryId === queryId);

        if (existingMapping) {
            // Update existing mapping with new widgetIds, avoiding duplicates
            existingMapping.widgetIds = Array.from(new Set([...existingMapping.widgetIds, ...widgetIds]));
        } else {
            // Add new mapping
            this.trebekQueryIdWidgetMappings.push({ queryId, widgetIds: Array.from(new Set(widgetIds)) });
        }
    }

    getTrebekQueryIdWidgetMappings(): QueryIdToWidgetId[] {
        return structuredClone(this.trebekQueryIdWidgetMappings);
    }
}

interface QueryIdToWidgetId {
    queryId: string;
    widgetIds: number[];
}
